// extracted by mini-css-extract-plugin
export var collage = "Collage-module--collage--2QfQg";
export var item = "Collage-module--item--1FRyo";
export var root = "Collage-module--root--1Fpux";